/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tariffsearch.js                                                                     */
/**********************************************************************************************************************/
/* Controller.TariffSearch */

/**
 * @class this.Controller.TariffSearch
 */
HafasWebapp.prototype.Controller.TariffSearch = {
  /**
   * @class this.Controller.TariffSearch.index
   *
   * @param data
   */
  currentView: null,
  tariffSelectBoxes: [],
  tariffFilter: {
    usageL: "ONEWAY",
    classL: "SECOND",
    cardL: "NONE",
    typePersL: "ADULT"
  },
  index: function () {
    Hafas.Modules.Loader.loadTemplateFiles(['tariffsearch.index.html','tariffsearch.form.input.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.TariffSearch.renderIndex, this)();
    }, this));
  },
  createIndexModel: function () {
    var model = {};
    return model;
  },
  renderIndex                : function () {

    var model = Hafas.bind(this.Controller.TariffSearch.createIndexModel, this)();

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("TariffSearch", "index", {});

    var me = this;

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffSearch.index +++ DEBUG Model +++', model)
    }

    Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("TariffSearch_TplIndex", model);


    var baseConfigTariffSearch = Hafas.Core.clone(Hafas.Config.Suggest);
    baseConfigTariffSearch.useNearLocation = false;
    baseConfigTariffSearch.useHistoryLocations = 'NONE';

    me.Controller.TariffSearch.inpFrom = Hafas.Core.newType('hafasSuggest', {
      loc     : "TariffSearch_From",
      config  : baseConfigTariffSearch,
      type    : "S",
      onSelect: function (loc) {
        me.Controller.TariffSearch.instance.setLocation('dep', loc);
      },
      onClear: function() {
        Hafas.ps.pub('/map/clearLocationMarker', ["dep"]);
      }
    });

    me.Controller.TariffSearch.inpTo   = Hafas.Core.newType('hafasSuggest', {
      loc     : "TariffSearch_To",
      config  : baseConfigTariffSearch,
      type    : "Z",
      onSelect: function (loc) {
        me.Controller.TariffSearch.instance.setLocation('arr', loc);
      },
      onClear: function() {
        Hafas.ps.pub('/map/clearLocationMarker', ["arr"]);
      }
    });

    var tmpLoc = me.Controller.TariffSearch.instance.getLocation("dep");
    if (tmpLoc != null) {
      me.Controller.TariffSearch.inpFrom.setLocation(tmpLoc);
    }

    tmpLoc = me.Controller.TariffSearch.instance.getLocation("arr");
    if (tmpLoc != null) {
      me.Controller.TariffSearch.inpTo.setLocation(tmpLoc);
    }


    // setting tdp-configuration
    var dateTimePickerConfig = {
      holder : "HFS_TariffSearchDateTimePickerHolder",
      id     : "TariffSearchDTP",
      config : {
        useDepArrSwitch: false,
        useTimePicker:false
      },
      current: {
        date   : me.Controller.TariffSearch.instance.getTravelDate(),
        time   : '000000',
        enquiry: false,
        isNowMode: me.Controller.TariffSearch.instance.getTimeNow()
      }
    };

    me.Controller.TariffSearch.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
    me.Controller.TariffSearch.currentView = "index";


    Hafas.ps.pub('/app/events/renderDone');

    
    // f?lle die UIActions des TariffSearch-Moduls
    // TariffSearch_TplFormUIActions
    if (Hafas("#" + me.formUIHiddenActions)) {
      Hafas("#" + me.formUIHiddenActions).innerHTML = Hafas.Modules.Render.renderTemplate("Common_TplFormUIActions", {appcontext: 'TariffSearch'});
    }

    // Tracking (TBD)
    // Hafas.ps.pub('/tracking/screen/journey-planner-main', [ { typ: 'screen', key: 'journey-planner-main' } ]);
    // Hafas.ps.pub('/tracking/screen/tripplanner-main', [ { typ: 'screen', key: 'tripplanner-main' } ]);

    Hafas.ps.pub('/GUI/form/show', [{}]);
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
  },
  hideInputField: function(type){
    var inputFieldContainer = Hafas('#HFS_TariffSearchInput'+ type +'Wrap',false);
    Hafas.Util.gui.setVisibility(inputFieldContainer,false);
  },
  hideDate: function(){
    Hafas.Util.gui.setVisibility(Hafas('#HFS_TariffSearchDateTimePickerWrap'),false);
  },
  setMetaFilter: function(type,metaFltr){
    this.Controller.TariffSearch["inp" + type].setLocationFilter({"type":"META","mode": "INC","value":metaFltr});
  },
  setTariffContext: function(ctx){
    this.Controller.TariffSearch.instance.setTariffContext(ctx);
  },
  validate: function (data, callback) {
    if (data[0] == 'From') {
      var locationId = 'dep';
    } else if (data[0] == 'To') {
      var locationId = 'arr';
    }
    var location = this.main.Controller.TariffSearch.instance.getLocation(locationId);
    if (this.main.Controller.TariffSearch['inp' + data[0]].getInputText().length == 0) {
      this.main.Controller.TariffSearch.instance.setLocation(locationId, null);
    }
    if ((this.main.Controller.TariffSearch['inp' + data[0]].getInputText().length > 0) && ((location == null) || (this.main.Controller.TariffSearch['inp' + data[0]].getInputText() != location.name))) {
      this.main.Controller.TariffSearch['inp' + data[0]].validateLocation(true, Hafas.bind(function () {
        data.shift();
        if (data.length > 0) {
          this.main.Controller.TariffSearch.validate(data, callback);
        } else {
          callback();
        }
      }, this));
    } else {
      data.shift();
      if (data.length > 0) {
        this.main.Controller.TariffSearch.validate(data, callback);
      } else {
        callback();
      }
    }
    return false;
  },
  postForm: function (data) {
    var _me = this;

    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();

    //Wird die Suche durch extere Parameter gestartet.
    data.searchFromExternal = !!data.searchFromExternal;

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');


    try {
      this.Controller.TariffSearch.validate(['From', 'To'], Hafas.bind(function () {
        var form = Hafas.Core.newType("hafasValidation", {
          form: data.form
        });
        // If input are valid -> proceed with connection search
        if (form.valid) {
          // show loadingImage and set Button to disabled
          if (data.form.elements.submitTariffSearchForm) {
            Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitTariffSearchForm);
          }

          // Search tariffs
          this.Controller.TariffSearch.instance.search({
            callback: Hafas.bind(this.Controller.TariffSearch.showResultOverview,this)
          });


          // Track
          Hafas.ps.pub('/tracking/event/connection-request', ['[' + _me.appContext + '] SEARCH: ' + data.form.elements.TariffSearch_From.value + ' --> ' + data.form.elements.TariffSearch_To.value]);

          if (data.searchFromExternal) {
            Hafas.bind(this.Controller.TariffSearch.showWaitView, this)(Hafas.Modules.i18n.get('TP.index.t_N_WaitSearchConnection'));
          }

        }
      }, this));

      if (!Hafas.Config.showOptionsOnInit) {
        Hafas.ps.pub('/GUI/tabs/closeAll');
        Hafas.ps.pub('/GUI/options/closeAll');
      }
      Hafas.ps.pub('/app/events/resize');
    }catch(e){
      console.log(e);
    }
    return false;
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, enquiry, setTimeNow) {
    this.Controller.TariffSearch.instance.setTravelDate(hciDate);
    this.Controller.TariffSearch.instance.setTimeNow(setTimeNow);

  },
  chooseVariant: function(ctx){
    if(ctx.length > 0){
      this.Controller.TariffSearch.instance.searchByCtx(ctx);
    }
  },
  showResultOverview: function(data) {
    Hafas.Modules.History.addOrUpdateData("TariffSearch", "overview", data);

    if (!Hafas.Config.showFormOnResult) {
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TariffSearch'}]);
    }

    var filterInfo = Hafas.Util.Tariffs.resolveFilterProperties(data.fareSetL);
    this.Controller.TariffSearch.filterInfo = filterInfo;

    // FareSets alle initial anzeigen
    for(var d=0; d < data.fareSetL.length;d++){
      data.fareSetL[d].showInitially = true;
    }

    var model = {
      tariffInfoBox:{
        fareSetListResolved: data.fareSetL
      },
      showFilter: filterInfo.filterFound,
      filter: Hafas.Util.Tariffs.getDefaultTariffFilter(this.Controller.TariffSearch.tariffFilter,filterInfo.foundFilters,'tariffsearch'),
      ctx: 'tariffsearch'
    };
    if(typeof data.variantL != 'undefined'){
      model.variantList = data.variantL;
    }else{
      model.variantList = [];
    }
    model.viewHeader = {
      overview: Hafas.Modules.i18n.get('TariffSearch.index.t_N_Overview')
    };

    Hafas.ps.pub('/GUI/results/overview/show', [{}]);

    // is defined in classic-Version GUI-Functions
    Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

    this.Controller.TariffSearch.currentView = "overview";

    Hafas.Modules.Loader.loadTemplateFiles(['tariffs.index.html','tp.result.detail.html'], Hafas.bind(function() {
      Hafas.Modules.Render.render({
        file: 'tariffsearch.result.overview.html',
        target: 'TariffSearch_ResultOverview',
        template: 'TariffSearch_TplOverview',
        model: model
      }, Hafas.bind(function () {

        if(model.variantList.length > 0) {
          var tmpSelectBox = Hafas.Core.newType('HafasSelectBox', {
            holder: 'HFS_TariffSearchVariantList_Holder', callback: function (data) {
              Hafas.ps.pub('/tariffsearch/chooseVariant', [decodeURIComponent(data.value)]);
            }
          });
          tmpSelectBox.initiate();
          this.Controller.TariffSearch.tariffSelectBoxes.push(tmpSelectBox);
        }

        if(filterInfo.filterFound) {
          Hafas.bind(this.Controller.TariffSearch.updateTariffFilterResults, this)(filterInfo.foundFilters);
        }

        Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
        Hafas.ps.pub('/app/events/resize');
      }, this));
    },this));
  },
  showErrorPage: function(data){
      if (!Hafas.Config.showFormOnResult) {
        Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TariffSearch'}]);
      }

      Hafas.Modules.History.addOrUpdateData("TariffSearch", "error", data);

      Hafas.ps.pub('/GUI/results/overview/show', [{}]);

      var model = {};
      model.viewHeader = {
        overview: Hafas.Modules.i18n.get('TariffSearch.index.t_N_Overview')
      };
      model.statusText = data.statusText;

      this.Controller.TariffSearch.currentView = "overview";

      Hafas.Modules.Render.render({
        file: 'tariffsearch.result.overview.html',
        target: 'TariffSearch_ResultOverview',
        template: 'TariffSearch_ErrorTpl',
        model: model
      }, Hafas.bind(function () {

        Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
        Hafas.ps.pub('/app/events/resize');
     }, this));
  },
  updateTariffOverview: function(data){
    this.Controller.TariffSearch.tariffFilter[data.key] = data.value;
    if(typeof this.Controller.TariffSearch.filterInfo != 'undefined'){
      Hafas.bind(this.Controller.TariffSearch.updateTariffFilterResults, this)(this.Controller.TariffSearch.filterInfo.foundFilters);
    }else {
      Hafas.bind(this.Controller.TariffSearch.updateTariffFilterResults, this)();
    }
  },
  updateTariffFilterResults: function(usedFilters){
    Hafas('[data-tariff-fareset="item"]',true).forEach(function(elem){
      Hafas.Util.gui.setVisibility(elem,false);
    });
    var queryString = '';
    for(var t in this.Controller.TariffSearch.tariffFilter){
      if(typeof usedFilters == 'undefined' || typeof usedFilters[t] != 'undefined') {
        queryString += '[data-' + t.toLowerCase() + '=' + this.Controller.TariffSearch.tariffFilter[t] + ']';
      }
    }
    var domElems = Hafas(queryString,true);
    if(domElems != null) {
      domElems.forEach(function (elem) {
        Hafas.Util.gui.setVisibility(elem, true);
      });
    }
  },
  toggleFareSet: function(idx,boolval){
    var faresetToToggle = Hafas('[data-tariff-fareset-id="' + idx + '"]',false);
    Hafas.Util.gui.setVisibility(faresetToToggle,boolval);
  },
  switchFromTo: function() {
    this.Controller.TariffSearch.instance.switchLocations();
  },
  setGeoLocationPosition: function (locObj, inputId) {
    if (inputId == "TariffSearch_From")
      this.Controller.TariffSearch.instance.setLocation('dep', locObj);
  },
  closeView              : function (histData) {
    // console.log("+++ close view +++", histData);
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      case "overview":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "details":
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }

  },
  restoreView            : function (histData) {
    // console.log("+++ restore view +++", histData);
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.bind(this.Controller.TariffSearch.renderIndex, this)(histData.data);
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/app/events/resize',[]);
        break;
      case "overview":
        break;
      case "details":
        if (this.Controller.Map.instance) {
          this.Controller.Map.hideConnection();
        }
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderDefault'}]);
        break;
      case "tariffInfoBoxGroup":
        Hafas.bind(this.Controller.TP.renderTariffInfoBoxGroups, this)(histData.data, { });
        break;
    }
  },
  cleanMap: function () {
    if (typeof this.Controller.Map != 'undefined') {
      this.Controller.Map.hideConnection();
      this.Controller.Map.hideTripMarker();
    }
  },
  cleanup: function () {
    Hafas('#TariffSearch_ResultOverview',false).innerHTML ='';

    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
  }
};
